'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from '@benzinga/core-ui';
import styles from './content.module.css';
import type { News as NewsI } from '@benzinga/basic-news-manager';
import type { BaseQuotePageProps } from '../../../../../src/utils/quote/types';

import News from '../../../../../src/components/Quote/News';
import Peers from '../../../../../src/components/Quote/Peers';
import DefaultSidebar from '../../../../../src/components/Sidebars/DefaultSidebar';

interface NewsContentProps extends BaseQuotePageProps {
  quoteNews: NewsI[];
  symbolForNews?: string;
}

const NewsContent: React.FC<NewsContentProps> = ({
  metaProps,
  profile,
  quoteNews,
  symbol,
  symbolForNews = symbol,
}) => {
  const { t } = useTranslation('quote');

  return (
    <>
      <div className={`${styles.wrapper} main-div`}>
        <div className="flex flex-col gap-4 lg:flex-row w-full">
          <div className="w-full lg:w-9/12">
            <div className="main-div divider-bottom mb-4">
              <div className="flex flex-col gap-2 mb-4">
                <SectionTitle level={1} uppercase={false}>
                  {metaProps.title}
                </SectionTitle>
                <p className="section-description">
                  {t('Quote.Paragraphs.news', { stockName: profile?.richQuoteData?.name })}
                </p>
              </div>
            </div>
            <div className="mt-4">
              <News initialNews={quoteNews} symbol={symbolForNews} />
            </div>
          </div>
          {!profile.isETF && (profile.peerSymbols?.length ?? 0) > 0 && (
            <div className="w-full lg:w-3/12">
              <React.Suspense>
                <DefaultSidebar>
                  <div className="w-full">
                    <SectionTitle level={3} size="2xl">
                      {t('Quote.Peers.people-also-watch')}
                    </SectionTitle>
                    <Peers
                      peers={profile.peers}
                      peerSymbols={profile.peerSymbols}
                      showTitle={false}
                      symbol={symbol}
                      type={profile.schedule?.type || 'REGULAR'}
                    />
                  </div>
                </DefaultSidebar>
              </React.Suspense>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NewsContent;

